import React, { useMemo } from 'react';
import { InputCalendar } from '@components/forms/input-calendar';
import { useFormContext } from '@goodfynd/forms';
import { FlexView } from '@goodfynd/ui';
import { Text } from '@goodfynd/ui';
import { dateUtil, vendorUtil } from 'utils/index';

import { ReviewTextField } from '../../../../components/vendors/FormVendor/ReviewModal/ReviewTextField';
import config from '../../../../config';

import type { ScheduleWizardFields } from './types';

export function StepOperatingDays() {
  const { control } = useFormContext<ScheduleWizardFields>();

  return (
    <>
      <Text as="body2">
        Select the days you will be open. If you will be at the same location
        for multiple days, you can select all those days now.
      </Text>

      <InputCalendar
        control={control}
        name="dates"
        inputProps={{
          minDate: new Date(),
        }}
      />
    </>
  );
}

export function StepOperatingDaysSummary() {
  const { getValues } = useFormContext<ScheduleWizardFields>();
  const {
    dates = [],
    end,
    start,
    existingScheduleDictionary = {},
  } = getValues();

  const { invalid, ranges } = useMemo(
    () =>
      dateUtil.getDateRanges(dates || [], (date) =>
        vendorUtil.validateSchedule(
          {
            end: dateUtil.setTime(date, end as Date),
            start: dateUtil.setTime(date, start as Date),
          },
          existingScheduleDictionary[
            dateUtil.format(date, config.dateFormats.yearMonthDay)
          ]
        )
      ),
    [dates, end, start, existingScheduleDictionary]
  );

  const validDates = ranges;
  const invalidDates = invalid;

  return (
    <FlexView gap={32}>
      {validDates.length > 0 && (
        <ReviewTextField
          label="Valid Dates"
          value={
            <span
              dangerouslySetInnerHTML={{
                __html: dateUtil.printDateRanges(validDates, '<br />'),
              }}
            />
          }
        />
      )}

      {invalidDates.length > 0 && (
        <ReviewTextField
          label="Conflicted Dates"
          css={{
            color: '$RedBrand',
          }}
          value={
            <span
              title="These dates will not be added to your calendar."
              dangerouslySetInnerHTML={{
                __html: dateUtil.printDateRanges(invalidDates, '<br />'),
              }}
            />
          }
        />
      )}
    </FlexView>
  );
}
